import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: "top" },
    theme: { type: String, default: "light" }
  }

  connect() {
    this.tooltip = tippy(this.element, {
      content: this.contentValue,
      placement: this.placementValue,
      theme: this.themeValue,
      arrow: true,
      animation: 'fade',
      duration: [200, 150],
      interactive: true,
      maxWidth: 300,
      allowHTML: true
    })
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.destroy()
    }
  }
}
